module.exports = __webpack_public_path__ + "img/bd-img.17b8a8e1.jpg";